/*--------------------------------------------------
M I P A
--------------------------------------------------*/
import { scrollbarCompensation } from './js/hooks/utils'
import { system, mobile } from './js/hooks/device'
import Events from '@/js/core/EventDispatcher'
import * as components from '@/js/components'
import * as includes from '@/js/includes'
import LazyLoad from 'vanilla-lazyload'
import 'intersection-observer'
import sal from 'sal.js'
import gsap from 'gsap'
import $ from 'jquery'
window.jQuery = $


/*--------------------------------------------------
Theme
--------------------------------------------------*/
import 'swiper/swiper.scss'
import '@/scss/theme.scss'


/*--------------------------------------------------
jQuery extends
--------------------------------------------------*/
$.extend({
  device: { 
    ...system, mobile,
    android: !!~system.os.indexOf('android'),
    ios: !!~system.os.indexOf('ios'),
  },
})

$.fn.extend({
  backgroundColor: function () {
    return this.each(function () {
      $(this).css($(this).data())
    })
  },

  ratio: function () {
    return this.each(function () {
      const $ratio = $(this).find('.ratio')
      const data = $(this).data()
      const size = data.imageRatio.split('x')
      const ratio = size[1] / size[0] * 100
      $ratio.css({ padding: `${ratio}% 0 0` })
      $(this).attr('data-setup', '')
    })
  },
})


/*------------------------------
Init
------------------------------*/
const init = () => {
  body()
  lazy()
  invp()
  sal({
    threshold: .05,
  })
}

const body = () => {
  $(document.body).addClass($.device.mobile ? 'touch' : 'no-touch')
}

const lazy = () => {
  const lazyLoad = new LazyLoad({})
  Events.on('layout:update', () => {
    lazyLoad.update()
  })
}

const invp = () => {
  const observer = new IntersectionObserver((entries /* observer */) => {
    entries.forEach(({ target, isIntersecting }) => {
      Events.emit('intersect:update', { target, isIntersecting })
      /* const $target = $(target)
      if (!isIntersecting) {
        $target.not('.revealed').addClass('hidden')
        $target.attr('data-hidden', '')
      } else {
        $target.removeClass('hidden').addClass('revealed')
        $target.removeAttr('data-hidden')
        $target.addClass('revealed')
      } */
    })
  }, { threshold: .01 })

  $('main > div:not([class*="-grid"]), [class*="-grid"] [class*="-card "]')
    .each((_, element) => 
      observer.observe(element))
}


/*------------------------------
Setup
------------------------------*/
const setup = () => {
  setupComponentInstances()
  setupComponentBgColor()
  setupComponentRatio()
  setupComponentFocus()
}

const setupComponentInstances = () => {
  for (const key in components) {
    const Component = components[key]
    const $root = $(Component.root)
    if ($root.length) {
      $root.each((_, element) => {
        new Component().mount(element)
      })
    }
  }

  for (const key in includes) {
    const Component = includes[key]
    const $root = $(Component.root)
    if ($root.length) {
      $root.each((_, element) => {
        new Component().mount(element)
      })
    }
  }
}

const setupComponentBgColor = () => {
  $('[data-background-color]').backgroundColor()
}

const setupComponentRatio = () => {
  $('[data-image-ratio]').not('[data-setup]').ratio()
}

const setupComponentFocus = () => {
  if (!$.device.mobile) {
    $(document)
      .on('mouseenter', '[data-focus]', function () {
        $(this).parents('[class*="-card "]').addClass('focus')
      })
      .on('mouseleave', '[data-focus]', function () {
        $(this).parents('[class*="-card "]').removeClass('focus')
      })
  }
}


/*------------------------------
Ready
------------------------------*/
const ready = () => {
  if ($(document.body).hasClass('loader--active')) {
    Events.emit('dom:ready')
  }
}


/*------------------------------
Resize
------------------------------*/
let lastinnerWidth = 0

const viewportNeedUpdates = () => {
  return (!$.device.mobile) || ($.device.mobile && window.innerWidth !== lastinnerWidth)
}

const resize = () => {
  if (viewportNeedUpdates())
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`)
  document.documentElement.style.setProperty('--sw', `${scrollbarCompensation()}px`)
  lastinnerWidth = window.innerWidth
}

$(window).on('resize', resize)


/*------------------------------
Dom Ready
------------------------------*/
resize()

let timeout = null

$(() => {
  init()
  setup()
  
  timeout = gsap.delayedCall(2.5, () => {
    ready()
  })

  
})

$(window).on('load', () => {
  timeout.kill()
  ready()

  
})

$(window).on('pageshow', (event) => {
  if (event.originalEvent.persisted) {
    timeout.kill()
    ready()
  } 
})

